import { useEffect } from 'react'
import { ErrorEnum } from '@/utils/announcements'
import {useAnnouncementsContext} from "@/contexts/AnnouncementsContext";

const useInternetConnection = (): void => {
  const { addAnnouncement, removeAnnouncement } = useAnnouncementsContext()

  useEffect(() => {
    const onOnline = () => removeAnnouncement(ErrorEnum.NO_INTERNET_CONNECTION)
    const onOffline = () => addAnnouncement(ErrorEnum.NO_INTERNET_CONNECTION)

    window.addEventListener('online', onOnline)
    window.addEventListener('offline', onOffline)

    return () => {
      window.removeEventListener('online', onOnline)
      window.removeEventListener('offline', onOffline)
    }
  }, [addAnnouncement, removeAnnouncement])
}

export default useInternetConnection
